module.exports = __webpack_public_path__ + "img/logo-googlecalendar.8297cf2c.svg";